import React, { Component } from 'react'

export class Support extends Component {
  render() {
    return (
      <div style={{textAlign:'center',marginTop:'-65px'}}>
        <div className="title" style={{fontSize:'34px',fontWeight:'bold'}}>技术支持</div>
        <div className="intr" style={{fontSize:'16px'}}>使用过程中遇到任何问题，欢迎邮件或致电我们：</div>
        <div className="email" style={{fontSize:'16px'}}>email：chenbang-admin@chenbang-inc.com</div>
        <div className="tel" style={{fontSize:'16px'}}>电话/tel：4001108865</div>
      </div>
    )
  }
}


export default Support
